// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.carousel-section {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 20px;
}
@media (max-width: 768px) {
  .carousel-section {
    padding: 0 10px;
  }
}

.carousel {
  position: relative;
  padding: 0 25px;
}
@media (max-width: 640px) {
  .carousel {
    padding: 0 15px;
  }
}

.home-carousel-grid {
  display: flex;
  justify-content: center;
  align-items: stretch;
  gap: 14px;
  padding: 8px 4px 14px;
}
@media (max-width: 640px) {
  .home-carousel-grid {
    gap: 10px;
    padding: 6px 2px 10px;
  }
}

.product-card-wrapper {
  flex: 1 1 0px;
  max-width: 260px;
  min-width: 0;
  display: flex;
}
@media (max-width: 640px) {
  .product-card-wrapper {
    max-width: 250px;
  }
}

/* ==========================================================================
   Card de Producto (Idéntica a la Tienda)
   ========================================================================== */
.home-card.card {
  width: 100%;
  height: auto;
  min-height: 0;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  position: relative;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.home-card.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}
.home-card.card .img-container {
  width: 100%;
  height: 175px;
  padding: 8px;
  background: #fafafa;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
@media (max-width: 640px) {
  .home-card.card .img-container {
    height: 160px;
  }
}
.home-card.card .img-container .img-publica {
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
  transition: transform 0.2s ease;
}
.home-card.card .flag-mayorista {
  position: absolute;
  top: 0;
  left: 0;
  height: 55px;
  width: auto;
  z-index: 5;
  margin: 0 !important;
  pointer-events: none;
}
@media (max-width: 640px) {
  .home-card.card .flag-mayorista {
    height: 52px;
  }
}
.home-card.card .body {
  padding: 10px 10px 8px;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
}
.home-card.card .body .name {
  height: 36px;
  margin-bottom: 4px;
}
.home-card.card .body .name p {
  font-size: 0.82rem;
  font-weight: 600;
  line-height: 1.25;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: #1f2937;
}
.home-card.card .body .price {
  margin: 2px 0 6px;
  height: auto;
}
.home-card.card .body .price .card-title {
  font-size: 1.02rem;
  font-weight: 700;
  color: #dc2626;
  margin: 0;
}
.home-card.card .body .options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 4px;
  border-top: 1px solid #f3f4f6;
}
.home-card.card .body .options .vermas {
  font-size: 0.78rem;
  font-weight: 600;
  color: #2563eb;
  margin: 0;
  cursor: pointer;
  text-decoration: none;
}
.home-card.card .body .options .vermas:hover {
  color: #1d4ed8;
  text-decoration: underline;
}
.home-card.card .body .options .icon {
  font-size: 1.35rem;
  color: #1f2937;
  cursor: pointer;
  transition: color 0.15s ease, transform 0.15s ease;
}
.home-card.card .body .options .icon:hover {
  color: #dc2626;
  transform: scale(1.15);
}
.home-card.card .body .options .icon.text-muted {
  color: #9ca3af !important;
  cursor: not-allowed;
}
.home-card.card .body .options .icon.text-muted:hover {
  transform: none;
}

/* ==========================================================================
   Controles del Carrusel
   ========================================================================== */
.carousel-control-prev,
.carousel-control-next {
  width: 38px;
  height: 38px;
  top: 50%;
  transform: translateY(-50%);
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  border-radius: 50%;
  opacity: 0.92;
  transition: all 0.2s ease;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}
.carousel-control-prev .carousel-control-prev-icon,
.carousel-control-prev .carousel-control-next-icon,
.carousel-control-next .carousel-control-prev-icon,
.carousel-control-next .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
  width: 18px;
  height: 18px;
}
.carousel-control-prev:hover,
.carousel-control-next:hover {
  background-color: #dc2626;
  border-color: #dc2626;
  opacity: 1;
  transform: translateY(-50%) scale(1.08);
}
.carousel-control-prev:hover .carousel-control-prev-icon,
.carousel-control-prev:hover .carousel-control-next-icon,
.carousel-control-next:hover .carousel-control-prev-icon,
.carousel-control-next:hover .carousel-control-next-icon {
  filter: none;
}
@media (max-width: 640px) {
  .carousel-control-prev,
  .carousel-control-next {
    width: 32px;
    height: 32px;
  }
  .carousel-control-prev .carousel-control-prev-icon,
  .carousel-control-prev .carousel-control-next-icon,
  .carousel-control-next .carousel-control-prev-icon,
  .carousel-control-next .carousel-control-next-icon {
    width: 15px;
    height: 15px;
  }
}

.carousel-control-prev {
  left: -5px;
}
@media (max-width: 640px) {
  .carousel-control-prev {
    left: -2px;
  }
}

.carousel-control-next {
  right: -5px;
}
@media (max-width: 640px) {
  .carousel-control-next {
    right: -2px;
  }
}

.pointer {
  cursor: pointer;
}

/* ==========================================================================
   Modal Flotante de Carrito
   ========================================================================== */
.cart-modal {
  position: fixed;
  z-index: 1050;
  top: 130px;
  right: 25px;
  animation: slideInRight 0.3s ease-out;
}
@media (max-width: 768px) {
  .cart-modal {
    top: 90px;
    right: 12px;
    left: 12px;
  }
}
.cart-modal .alert {
  border-radius: 12px;
  font-weight: 500;
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./../../Universo%20Tunning/ecommerce/src/app/pages/home/home.component.scss","webpack://./src/app/pages/home/home.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACE,iBAAA;EACA,cAAA;EACA,eAAA;ADEF;ACAE;EALF;IAMI,eAAA;EDGF;AACF;;ACAA;EACE,kBAAA;EACA,eAAA;ADGF;ACDE;EAJF;IAKI,eAAA;EDIF;AACF;;ACDA;EACE,aAAA;EACA,uBAAA;EACA,oBAAA;EACA,SAAA;EACA,qBAAA;ADIF;ACFE;EAPF;IAQI,SAAA;IACA,qBAAA;EDKF;AACF;;ACFA;EACE,aAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;ADKF;ACHE;EANF;IAOI,gBAAA;EDMF;AACF;;ACHA;;+EAAA;AAGA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qDAAA;ADMF;ACJE;EACE,2BAAA;EACA,0CAAA;ADMJ;ACHE;EACE,WAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;ADKJ;ACHI;EAVF;IAWI,aAAA;EDMJ;AACF;ACJI;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,+BAAA;ADMN;ACFE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;EACA,oBAAA;ADIJ;ACFI;EAVF;IAWI,YAAA;EDKJ;AACF;ACFE;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,OAAA;EACA,8BAAA;ADIJ;ACFI;EACE,YAAA;EACA,kBAAA;ADIN;ACFM;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,cAAA;ADIR;ACAI;EACE,iBAAA;EACA,YAAA;ADEN;ACAM;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;ADER;ACEI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,6BAAA;ADAN;ACEM;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA;EACA,qBAAA;ADAR;ACEQ;EACE,cAAA;EACA,0BAAA;ADAV;ACIM;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kDAAA;ADFR;ACIQ;EACE,cAAA;EACA,sBAAA;ADFV;ACKQ;EACE,yBAAA;EACA,mBAAA;ADHV;ACIU;EACE,eAAA;ADFZ;;ACUA;;+EAAA;AAGA;;EAEE,WAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;EACA,yBAAA;EACA,yBAAA;EACA,yCAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ADPF;ACSE;;;;EAEE,gCAAA;EACA,WAAA;EACA,YAAA;ADLJ;ACQE;;EACE,yBAAA;EACA,qBAAA;EACA,UAAA;EACA,uCAAA;ADLJ;ACOI;;;;EAEE,YAAA;ADHN;ACOE;EApCF;;IAqCI,WAAA;IACA,YAAA;EDHF;ECKE;;;;IAEE,WAAA;IACA,YAAA;EDDJ;AACF;;ACKA;EACE,UAAA;ADFF;ACGE;EAFF;IAGI,UAAA;EDAF;AACF;;ACGA;EACE,WAAA;ADAF;ACCE;EAFF;IAGI,WAAA;EDEF;AACF;;ACCA;EACE,eAAA;ADEF;;ACCA;;+EAAA;AAGA;EACE,eAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;EACA,qCAAA;ADEF;ACAE;EAPF;IAQI,SAAA;IACA,WAAA;IACA,UAAA;EDGF;AACF;ACDE;EACE,mBAAA;EACA,gBAAA;ADGJ;;ACCA;EACE;IACE,2BAAA;IACA,UAAA;EDEF;ECAA;IACE,wBAAA;IACA,UAAA;EDEF;AACF","sourcesContent":["@charset \"UTF-8\";\n.carousel-section {\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n@media (max-width: 768px) {\n  .carousel-section {\n    padding: 0 10px;\n  }\n}\n\n.carousel {\n  position: relative;\n  padding: 0 25px;\n}\n@media (max-width: 640px) {\n  .carousel {\n    padding: 0 15px;\n  }\n}\n\n.home-carousel-grid {\n  display: flex;\n  justify-content: center;\n  align-items: stretch;\n  gap: 14px;\n  padding: 8px 4px 14px;\n}\n@media (max-width: 640px) {\n  .home-carousel-grid {\n    gap: 10px;\n    padding: 6px 2px 10px;\n  }\n}\n\n.product-card-wrapper {\n  flex: 1 1 0px;\n  max-width: 260px;\n  min-width: 0;\n  display: flex;\n}\n@media (max-width: 640px) {\n  .product-card-wrapper {\n    max-width: 250px;\n  }\n}\n\n/* ==========================================================================\n   Card de Producto (Idéntica a la Tienda)\n   ========================================================================== */\n.home-card.card {\n  width: 100%;\n  height: auto;\n  min-height: 0;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  overflow: hidden;\n  position: relative;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n.home-card.card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);\n}\n.home-card.card .img-container {\n  width: 100%;\n  height: 175px;\n  padding: 8px;\n  background: #fafafa;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n@media (max-width: 640px) {\n  .home-card.card .img-container {\n    height: 160px;\n  }\n}\n.home-card.card .img-container .img-publica {\n  max-height: 100%;\n  max-width: 100%;\n  object-fit: contain;\n  transition: transform 0.2s ease;\n}\n.home-card.card .flag-mayorista {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 55px;\n  width: auto;\n  z-index: 5;\n  margin: 0 !important;\n  pointer-events: none;\n}\n@media (max-width: 640px) {\n  .home-card.card .flag-mayorista {\n    height: 52px;\n  }\n}\n.home-card.card .body {\n  padding: 10px 10px 8px;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  justify-content: space-between;\n}\n.home-card.card .body .name {\n  height: 36px;\n  margin-bottom: 4px;\n}\n.home-card.card .body .name p {\n  font-size: 0.82rem;\n  font-weight: 600;\n  line-height: 1.25;\n  margin: 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  color: #1f2937;\n}\n.home-card.card .body .price {\n  margin: 2px 0 6px;\n  height: auto;\n}\n.home-card.card .body .price .card-title {\n  font-size: 1.02rem;\n  font-weight: 700;\n  color: #dc2626;\n  margin: 0;\n}\n.home-card.card .body .options {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 4px;\n  border-top: 1px solid #f3f4f6;\n}\n.home-card.card .body .options .vermas {\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: #2563eb;\n  margin: 0;\n  cursor: pointer;\n  text-decoration: none;\n}\n.home-card.card .body .options .vermas:hover {\n  color: #1d4ed8;\n  text-decoration: underline;\n}\n.home-card.card .body .options .icon {\n  font-size: 1.35rem;\n  color: #1f2937;\n  cursor: pointer;\n  transition: color 0.15s ease, transform 0.15s ease;\n}\n.home-card.card .body .options .icon:hover {\n  color: #dc2626;\n  transform: scale(1.15);\n}\n.home-card.card .body .options .icon.text-muted {\n  color: #9ca3af !important;\n  cursor: not-allowed;\n}\n.home-card.card .body .options .icon.text-muted:hover {\n  transform: none;\n}\n\n/* ==========================================================================\n   Controles del Carrusel\n   ========================================================================== */\n.carousel-control-prev,\n.carousel-control-next {\n  width: 38px;\n  height: 38px;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: #ffffff;\n  border: 1px solid #e5e7eb;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n  border-radius: 50%;\n  opacity: 0.92;\n  transition: all 0.2s ease;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.carousel-control-prev .carousel-control-prev-icon,\n.carousel-control-prev .carousel-control-next-icon,\n.carousel-control-next .carousel-control-prev-icon,\n.carousel-control-next .carousel-control-next-icon {\n  filter: invert(1) grayscale(100);\n  width: 18px;\n  height: 18px;\n}\n.carousel-control-prev:hover,\n.carousel-control-next:hover {\n  background-color: #dc2626;\n  border-color: #dc2626;\n  opacity: 1;\n  transform: translateY(-50%) scale(1.08);\n}\n.carousel-control-prev:hover .carousel-control-prev-icon,\n.carousel-control-prev:hover .carousel-control-next-icon,\n.carousel-control-next:hover .carousel-control-prev-icon,\n.carousel-control-next:hover .carousel-control-next-icon {\n  filter: none;\n}\n@media (max-width: 640px) {\n  .carousel-control-prev,\n  .carousel-control-next {\n    width: 32px;\n    height: 32px;\n  }\n  .carousel-control-prev .carousel-control-prev-icon,\n  .carousel-control-prev .carousel-control-next-icon,\n  .carousel-control-next .carousel-control-prev-icon,\n  .carousel-control-next .carousel-control-next-icon {\n    width: 15px;\n    height: 15px;\n  }\n}\n\n.carousel-control-prev {\n  left: -5px;\n}\n@media (max-width: 640px) {\n  .carousel-control-prev {\n    left: -2px;\n  }\n}\n\n.carousel-control-next {\n  right: -5px;\n}\n@media (max-width: 640px) {\n  .carousel-control-next {\n    right: -2px;\n  }\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n/* ==========================================================================\n   Modal Flotante de Carrito\n   ========================================================================== */\n.cart-modal {\n  position: fixed;\n  z-index: 1050;\n  top: 130px;\n  right: 25px;\n  animation: slideInRight 0.3s ease-out;\n}\n@media (max-width: 768px) {\n  .cart-modal {\n    top: 90px;\n    right: 12px;\n    left: 12px;\n  }\n}\n.cart-modal .alert {\n  border-radius: 12px;\n  font-weight: 500;\n}\n\n@keyframes slideInRight {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}",".carousel-section {\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 0 20px;\n\n  @media (max-width: 768px) {\n    padding: 0 10px;\n  }\n}\n\n.carousel {\n  position: relative;\n  padding: 0 25px;\n\n  @media (max-width: 640px) {\n    padding: 0 15px;\n  }\n}\n\n.home-carousel-grid {\n  display: flex;\n  justify-content: center;\n  align-items: stretch;\n  gap: 14px;\n  padding: 8px 4px 14px;\n\n  @media (max-width: 640px) {\n    gap: 10px;\n    padding: 6px 2px 10px;\n  }\n}\n\n.product-card-wrapper {\n  flex: 1 1 0px;\n  max-width: 260px;\n  min-width: 0;\n  display: flex;\n\n  @media (max-width: 640px) {\n    max-width: 250px;\n  }\n}\n\n/* ==========================================================================\n   Card de Producto (Idéntica a la Tienda)\n   ========================================================================== */\n.home-card.card {\n  width: 100%;\n  height: auto;\n  min-height: 0;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  overflow: hidden;\n  position: relative;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);\n  }\n\n  .img-container {\n    width: 100%;\n    height: 175px;\n    padding: 8px;\n    background: #fafafa;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n\n    @media (max-width: 640px) {\n      height: 160px;\n    }\n\n    .img-publica {\n      max-height: 100%;\n      max-width: 100%;\n      object-fit: contain;\n      transition: transform 0.2s ease;\n    }\n  }\n\n  .flag-mayorista {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 55px;\n    width: auto;\n    z-index: 5;\n    margin: 0 !important;\n    pointer-events: none;\n\n    @media (max-width: 640px) {\n      height: 52px;\n    }\n  }\n\n  .body {\n    padding: 10px 10px 8px;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    justify-content: space-between;\n\n    .name {\n      height: 36px;\n      margin-bottom: 4px;\n\n      p {\n        font-size: 0.82rem;\n        font-weight: 600;\n        line-height: 1.25;\n        margin: 0;\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n        color: #1f2937;\n      }\n    }\n\n    .price {\n      margin: 2px 0 6px;\n      height: auto;\n\n      .card-title {\n        font-size: 1.02rem;\n        font-weight: 700;\n        color: #dc2626;\n        margin: 0;\n      }\n    }\n\n    .options {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding-top: 4px;\n      border-top: 1px solid #f3f4f6;\n\n      .vermas {\n        font-size: 0.78rem;\n        font-weight: 600;\n        color: #2563eb;\n        margin: 0;\n        cursor: pointer;\n        text-decoration: none;\n\n        &:hover {\n          color: #1d4ed8;\n          text-decoration: underline;\n        }\n      }\n\n      .icon {\n        font-size: 1.35rem;\n        color: #1f2937;\n        cursor: pointer;\n        transition: color 0.15s ease, transform 0.15s ease;\n\n        &:hover {\n          color: #dc2626;\n          transform: scale(1.15);\n        }\n\n        &.text-muted {\n          color: #9ca3af !important;\n          cursor: not-allowed;\n          &:hover {\n            transform: none;\n          }\n        }\n      }\n    }\n  }\n}\n\n/* ==========================================================================\n   Controles del Carrusel\n   ========================================================================== */\n.carousel-control-prev,\n.carousel-control-next {\n  width: 38px;\n  height: 38px;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: #ffffff;\n  border: 1px solid #e5e7eb;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n  border-radius: 50%;\n  opacity: 0.92;\n  transition: all 0.2s ease;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: invert(1) grayscale(100);\n    width: 18px;\n    height: 18px;\n  }\n\n  &:hover {\n    background-color: #dc2626;\n    border-color: #dc2626;\n    opacity: 1;\n    transform: translateY(-50%) scale(1.08);\n\n    .carousel-control-prev-icon,\n    .carousel-control-next-icon {\n      filter: none;\n    }\n  }\n\n  @media (max-width: 640px) {\n    width: 32px;\n    height: 32px;\n\n    .carousel-control-prev-icon,\n    .carousel-control-next-icon {\n      width: 15px;\n      height: 15px;\n    }\n  }\n}\n\n.carousel-control-prev {\n  left: -5px;\n  @media (max-width: 640px) {\n    left: -2px;\n  }\n}\n\n.carousel-control-next {\n  right: -5px;\n  @media (max-width: 640px) {\n    right: -2px;\n  }\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n/* ==========================================================================\n   Modal Flotante de Carrito\n   ========================================================================== */\n.cart-modal {\n  position: fixed;\n  z-index: 1050;\n  top: 130px;\n  right: 25px;\n  animation: slideInRight 0.3s ease-out;\n\n  @media (max-width: 768px) {\n    top: 90px;\n    right: 12px;\n    left: 12px;\n  }\n\n  .alert {\n    border-radius: 12px;\n    font-weight: 500;\n  }\n}\n\n@keyframes slideInRight {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
